




































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  props: {
    onClick: {
      default: () => ({}),
      type: Function,
    },
    icon: String,
  },
})
export default class RoundedButton extends Vue { }
